module.exports = __webpack_public_path__ + "static/media/dominique-crenn-AD-topbanner.c54dfca7.jpg";